import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { useNavigate, useParams } from "react-router-dom";



/**
 * AddUPI component provides a form for users to add their UPI ID details.
 * Handles validation, navigation, and submission logic for UPI information.
 */
const AddUPI = ({ login = null }) => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  const handleEditClick = () => {
    // Navigate back to the previous page
    navigate(-1);
  };

  const validationSchema = Yup.object().shape({
    upi_id: Yup.string().required("UPI ID is required"),
  });

  const formik = useFormik({
    initialValues: {
      upi_id: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true); // Start loading

        const requestBody = {
          user_id: userId,
          upi_id: values.upi_id,
        };

        navigate(`/${redirectUrl}/reconfirm-upi-details/${userId}`, {
          state: {
            // bankdetails: apiResponseData?.original?.data?.data,
            uservalue: requestBody,
            userId: userId,
          },
        });

      } catch (error) {
        //   alert("Error while saving UPI ID details");
      } finally {
        setLoading(false); // Stop loading
      }
    },
  });

  return (
    <>
      <div className="container vh-100 mt-4">
        <div className="row">
          <div className="col-md-5 mt-15">
            <div className="text-center mb-3">
              <img
                width="300"
                alt="icon"
                src={toAbsoluteUrl("/media/images/pan-topimg.png")}
              />
            </div>
          </div>
          <div className="col-md-7">
            <h1 className="mb-5">Add UPI ID</h1>
            <p className="mb-10 grey-text">Enter your UPI ID details below.</p>
            <h6>UPI ID</h6>
            <form className="kyc_user" onSubmit={formik.handleSubmit}>
              <input type="hidden" name="user_id" value="5" />
              <div className="form-group">
                <input
                  type="text"
                  name="upi_id"
                  placeholder="Enter"
                  className="form-control"
                  value={formik.values.upi_id}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.upi_id && formik.errors.upi_id && (
                  <p className="text-danger">{formik.errors.upi_id}</p>
                )}
              </div>

              <div className="btns cn-btn mt-10 d-flex">
                <button
                  type="button"
                  className="btn bgdark-blue text-white"
                  onClick={handleEditClick}
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="btn red-btn text-white"
                  style={{
                    backgroundColor: loading ? "#999" : "red-btn text-white",
                    color: "white",
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? "Submitting..." : "Next"}
                </button>
              </div>
            </form>

            {/* <div className="mt-6">
              <Link
                to="/select-payment-method"
                className="grey-text text-decoration-underline"
              >
                How to Find UPI ID
              </Link>
            </div> */}
          </div>
        </div>
      </div>
      {/* {/* <ToastContainer />  */}
    </>
  );
};

export default AddUPI;
